/***************************************************************************************************
** buildInterpolationData
***************************************************************************************************/

export default function buildInterpolationData({
  kinndom = {},
  record = {},
}) {
  return {
    kinndomKey: window.appContext.kinndomKey,
    defaultWebsiteId: window.appContext.defaultWebsiteId,
    defaultWebsiteBaseUrl: window.appContext.defaultWebsiteBaseUrl,

    kinndom: kinndom,
    config: kinndom.configuration,
    session: {
      currentUserId: window.appContext.currentUserId,
      currentUserIpAddress: window.appContext.currentUserIpAddress,
      currentUserAgent: window.appContext.currentUserAgent,
      isCurrentUserAdmin: window.appContext.isCurrentUserAdmin,
    },
    ...record,
  };
}
